module.exports = __webpack_public_path__ + "e09d5325f13e4966d3ba4e5ea9bb87bc.svg";